import React from "react";
import parse from "html-react-parser";

function getReplacedContent(elements) {
    return React.Children.map(elements, child => {
        if (child.props?.children && typeof child.props?.children === "string") {
            return React.cloneElement(child, child.props, child.props.children.replace(/Ϲ/g, "{").replace(/Ͻ/g, "}"));
        } else {
            return child;
        }
    });
}

function parseHTML(name: string, html: string) {
    if (!html) return null;
    try {
        return parse(html);
    } catch (e) {
        console.error(`${name} widget error:`, e);
        return <div className="error-message">Error: Invalid html in "body" or "footer" for ${name} widget: {e.message}</div>;
    }
}

export default function renderContent(name, content) {
    return typeof content === 'string' ? parseHTML(name, content) : getReplacedContent(content);
}